<script setup lang="ts">
const route = useRoute()
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - SailingMetrics.com` : 'SailingMetrics.com';
  },
  meta: [
    { name: 'description', content: 'Join the SailingMetrics community to improve your sailing and dinghy sailing skills. Analyze your tracks and videos, compete and improve.' },
  ],
  link: [
      { rel: 'icon', type: 'image/png', href: '/favicon.png' },
    { rel: 'canonical', href: 'https://sailingmetrics.com' + route.path },
  ],
})
</script>

<template>
  <NuxtLoadingIndicator color="#0d47a1" />
  <NuxtLayout>
    <NuxtPage/>
  </NuxtLayout>
</template>
